
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  UserCurrencyUpdateRequest,
} from '../models';
import {
    UserCurrencyUpdateRequestFromJSON,
    UserCurrencyUpdateRequestToJSON,
} from '../models';

export interface UpdatePreferredCurrencyRequest {
    userCurrencyUpdateRequest: UserCurrencyUpdateRequest;
}

/**
 * 
 */
export class UserPreferencesApi extends runtime.BaseAPI {

    /**
          */
    async updatePreferredCurrencyRaw(requestParameters: UpdatePreferredCurrencyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['userCurrencyUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'userCurrencyUpdateRequest',
                'Required parameter "userCurrencyUpdateRequest" was null or undefined when calling updatePreferredCurrency().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/navbar/api/user-preferences/currency`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserCurrencyUpdateRequestToJSON(requestParameters['userCurrencyUpdateRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updatePreferredCurrency(requestParameters: UpdatePreferredCurrencyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePreferredCurrencyRaw(requestParameters, initOverrides);
    }

}
